import { useSidebar } from '@/components/ui/sidebar-context';
import { cn } from '@/lib/utils';

export function MetycleLogo({ className }: Readonly<{ className?: string }>) {
  const { open } = useSidebar();
  return open ? (
    <img src="/metycle-logo.png" alt="Metycle" className={cn('h-16 w-auto', className)} />
  ) : (
    <img
      src="/metycle-logo-mark.png"
      alt="Metycle"
      className={cn('h-8 w-8 object-contain', className)}
    />
  );
}
